import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Box, Button, Grid } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import NewButton from "../../components/Buttons/NewButton";
import UploadButton from "../../components/Buttons/UploadButton";
import ProgressIndicator from "../../components/ProgressIndicator";
import CustomMapComponent from "../../components/maps/CustomMapComponent";
import { getIcon } from "../../components/maps/getIcon";
import strings from "../../config/localization";
import _ from "lodash"

// import MantineReactTable, { MRT_ColumnDef, useMantineReactTable } from 'mantine-react-table'
import { MantineReactTable, useMantineReactTable, type MRT_ColumnDef, type MRT_Row } from 'mantine-react-table';

import {
  useGetAllLocationsQuery,
  useGetTimeslotsQuery,
  useSwapSerialNosMutation,
  useEditLocationMutation
} from "../../services/appln";
import { getDefaultLocation, getDefaultZoom } from "../constants";
import { doesPermissionExist, getLocationStrMap } from "../util";
import DeleteLocation from "./DeleteLocation";
import EditLocation from "./EditLocation";
import NewLocation from "./NewLocation";
import UploadLocations from "./UploadLocations";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}



function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function ListLocationsAsMap(props: any) {
  const [newDialogOpen, setNewDialogOpen] = React.useState(false);
  const [coordinate, setCoordinate] = React.useState(null);
  return (
    <>
      <CustomMapComponent
        data={props.data}
        onClose={() => {
          console.log("onCancelHandler");
        }}
        onSelect={(coordinate: any) => {
          console.log("XX: coordinate:", coordinate);
          setCoordinate(coordinate);
          setNewDialogOpen(true);
        }}
        defaultZoom={getDefaultZoom()}
        defaultCenter={getDefaultLocation()}
      />
      <NewLocation
        bandobastId={props.bandobastId!}
        timeslotId={props.timeslotId!}
        coordinate={coordinate}
        onSubmitHandler={(newObj: any) => {
          console.log("onSubmitHandler, newObj:", newObj);
          setNewDialogOpen(false);
        }}
        onCancelHandler={() => {
          console.log("onCancelHandler");
          setNewDialogOpen(false);
        }}
        state={newDialogOpen}
      />
    </>
  );
}

export default function ListLocations(props: any) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [timeslotMap, setTimeslotMap] = React.useState<any>(
    new Map<string, string>(),
  );

  const [selectedTimeslot, setSelectedTimeslot] = React.useState<any>("");

  const [locationDetails, setLocationDetails] = React.useState([]);
  const [coordinateDetails, setCoordinateDetails] = React.useState([]);

  const bandobastContext = JSON.parse(localStorage.getItem("bandobast")!);
  const timeslotContext = JSON.parse(localStorage.getItem("timeslot")!);

  const timeslotsQueryResponse = useGetTimeslotsQuery(props.bandobastId);
  React.useEffect(() => {
    if (!timeslotsQueryResponse.isSuccess) {
      return;
    }
    const timeslotMap = new Map<string, string>();
    timeslotsQueryResponse.data?.data.forEach((element: any) => {
      timeslotMap.set(element.name, element.id);
    });
    setSelectedTimeslot(timeslotsQueryResponse.data?.data[0].name);
    setTimeslotMap(timeslotMap);
  }, [timeslotsQueryResponse]);

  const locationsQueryResponse = useGetAllLocationsQuery({
    bandobastId: props.bandobastId,
    timeslotId: timeslotMap.get(selectedTimeslot)!,
  });

  React.useEffect(() => {
    if (locationsQueryResponse.isSuccess) {
      console.log(
        "ListLocations, locationsQueryResponse.data:",
        locationsQueryResponse.data,
      );
      const locationDetails = locationsQueryResponse.data.data.map<Location>(
        (e: any) => {
          return {
            serialNo: e.serialNo,
            key: e.id,
            name: e.name,
            address: e.address,
            kind: e.kind,
            parent: e.parentName,
            personnelAssessmentCount: e.personnelAssessmentCount,
            resourceAssessmentCount: e.resourceAssessmentCount,
            personnelAllocationCount: e.personnelAllocationCount,
            resourceAllocationCount: e.resourceAllocationCount,
          };
        },
      );
      setLocationDetails(locationDetails);

      const _populateColorMap = (data: any) => {
        // key: id, value: color
        const colorMap = new Map<string, string>();
        // console.log("_populateColorMap, data:", data);

        const colors = ["red", "blue", "green"];
        const dataCopy = JSON.parse(JSON.stringify(data));
        const ranges = dataCopy
          .filter((e: any) => {
            return e.kind === "range";
          })
          .map((e: any) => {
            return { ...e };
          });

        ranges.forEach((range: any, range_index: number) => {
          // console.log("_populateColorMap, range", range);
          colorMap.set(range.id, colors[range_index % colors.length]);
          const areas = dataCopy.filter((e: any) => {
            return e.kind === "area" && e.parentName === range.name;
          });
          // console.log("_populateColorMap, areas", areas);
          areas.forEach((area: any) => {
            colorMap.set(area.id, colors[range_index % colors.length]);
            const subareas = dataCopy.filter((e: any) => {
              return e.kind === "subarea" && e.parentName === area.name;
            });
            // console.log("_populateColorMap, subareas", subareas);
            subareas.forEach((subarea: any) => {
              colorMap.set(subarea.id, colors[range_index % colors.length]);
              const points = dataCopy.filter((e: any) => {
                return e.kind === "point" && e.parentName === subarea.name;
              });
              // console.log("_populateColorMap, points", points);
              points.forEach((point: any) => {
                colorMap.set(point.id, colors[range_index % colors.length]);
              });
            });
          });
        });
        // console.log("_populateColorMap, colorMap:", colorMap);
        return colorMap;
      };

      const locationsWithCoordinates = locationsQueryResponse.data.data.filter(
        (e: any) => {
          return e["geoJSON"];
        },
      );

      const colorMap = _populateColorMap(locationsWithCoordinates);

      const coordinateDetails = locationsWithCoordinates
        .filter((e: any) => {
          console.log("XX: e:", e["geoJSON"]);
          return e["geoJSON"];
        })
        .map((e: any) => {
          return {
            // latitude: parseFloat(e["latitude"]),
            // longitude: parseFloat(e["longitude"]),
            geoJSON: e["geoJSON"],
            kind: e.kind,
            title: `${e.name} (${e.kind})`,
            details: `${e.name} (${e.kind})`,
            color: colorMap.get(e.id)!,
            icon: getIcon(colorMap.get(e.id)!, e.kind),
          };
        });
      setCoordinateDetails(coordinateDetails);
    }
  }, [locationsQueryResponse]);

  return (
    <Box sx={{ width: "100%" }}>
      {(locationsQueryResponse.isLoading ||
        locationsQueryResponse.isFetching) && <ProgressIndicator />}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={Array.from(timeslotMap.keys())}
              value={selectedTimeslot}
              onChange={(e, value) => {
                setSelectedTimeslot(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="standard"
                  label={strings.timeslot}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label={strings.table}
                id="list-locations-as-table"
                aria-controls="list-locations-as-table"
              />
              <Tab
                label={strings.map}
                id="list-locations-as-map"
                aria-controls="list-locations-as-map"
              />
            </Tabs>
          </Grid>
        </Grid>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <ListLocationsAsTable
          data={locationDetails}
          bandobastId={props.bandobastId}
          timeslotId={timeslotMap.get(selectedTimeslot)!}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ListLocationsAsMap
          data={coordinateDetails}
          bandobastId={props.bandobastId}
          timeslotId={timeslotMap.get(selectedTimeslot)!}
        />
      </CustomTabPanel>
    </Box>
  );
}

interface Location {
  key: string;
  name: string;
  kind: string;
  parent: string;
  address: string;
  personnelAssessmentCount: number;
  resourceAssessmentCount: number;
  children?: Location[];
}

export function ListLocationsAsTable(props: any) {

  const [editLocation, editLocationParams] = useEditLocationMutation();


  const [swapSerialNos, swapSerialNoParams] = useSwapSerialNosMutation();
  const [data, setData] = React.useState(_transformData(props.data));


  type LocationTy = {
    name: string,
    kind: string,
    key: string,
    parent: string,
    personnelAllocationCount: number,
    personnelAssessmentCount: number,
    resourceAllocationCount : number,
    resourceAssessmentCount: number,
    children?: LocationTy[],
    subRows?: LocationTy[];
  }

  const columns2 = useMemo<MRT_ColumnDef<LocationTy>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'kind',
        header: 'Kind',
      },

      {
        accessorKey: 'personnelAssessmentCount',
        header: 'Personnel Assessment Count',
      },

      {
        accessorKey: 'personnelAllocationCount',
        header: 'Personnel Allocation Count',
      },
      {
        accessorKey: 'resourceAllocationCount',
        header: 'Device Allocation Count',
      },
      {
        accessorKey: 'resourceAssessmentCount',
        header: 'Device Assessment Count',
      },
      {
        accessorKey: 'edit',
        header: '',
        size: 40,
        enableColumnFilter: false, 
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ row }) =>
          doesPermissionExist('update-location') && (
            <EditLocation
              bandobastId={props.bandobastId}
              timeslotId={props.timeslotId}
              id={row.original.key}
              initialValues={row.original}
            />
          ),
      },
      {
        accessorKey: 'delete',
        header: '',
        enableColumnFilter: false,
        size: 40,
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ row }) =>
          doesPermissionExist('delete-location') && (
            <DeleteLocation
              bandobastId={props.bandobastId}
              timeslotId={props.timeslotId}
              id={row.original.key}
            />
          ),
      },

    ],
    [],
  );


  const table = useMantineReactTable({
    columns:columns2,
    data: data,
    enablePagination: false,
    enableBottomToolbar: false,
    enableExpanding: true,
    enableRowOrdering: true,
    mantineRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        const newData = _.cloneDeep(data)
        // console.log("Hovered Row --",(hoveredRow as MRT_Row<LocationTy>).original.parent)
        // console.log("Dragging Row --",draggingRow?.original.key)



        let hoveredParentName = (hoveredRow as MRT_Row<LocationTy>).original.parent
        const draggedKey = draggingRow?.original.key;
        const draggedElemKind = draggingRow?.original.kind;
        const hoveredName = (hoveredRow as MRT_Row<LocationTy>).original.name
        const hoveredKind = (hoveredRow as MRT_Row<LocationTy>).original.kind
        const hoveredKey = (hoveredRow as MRT_Row<LocationTy>).original.key
        const draggedElemName = draggingRow?.original.name;
        


        const straight: LocationTy[] = []; 

        const getMembers = (member: LocationTy): LocationTy | LocationTy[] => {
          // If no subRows or subRows are empty, return the member
          if (!member.subRows || member.subRows.length === 0) {
            return member;
          }
        
          // Recursively flatten the member with its subRows
          return [member, ..._.flatMapDeep(member.subRows, getMembers)];
        };

        const result = _.flatMapDeep(newData,getMembers)

        let hoveredParentkind = null;
        let hoveredParentId = null;

        for(let i = 0 ;i<result.length;i++){
          delete result[i].subRows;
          delete result[i].children;
          if(result[i].name == hoveredParentName){
            hoveredParentkind = result[i].kind
            hoveredParentId = result[i].key

          }
        }

        if(!(getAllowedParent(draggedElemKind) == hoveredParentkind)){
          if(!(getAllowedParent(draggedElemKind) == hoveredKind)){
            return;
          }

          hoveredParentName = hoveredName
          hoveredParentId = hoveredKey
        }

        for(let i = 0 ;i<result.length;i++){
          if(result[i].key == draggedKey){
            result[i].parent = hoveredParentName;
          }
        }
        
        
        editLocation({
          bandobastId: props.bandobastId,
          id: draggedKey,
          body: {
            address:"",
            kind:draggedElemKind,
            latitude:"",
            longitude:"",
            name:draggedElemName,
            parentId:hoveredParentId
          },
        });

        setData(_transformData(result))
        
      },
    })
  });


  const getAllowedParent = (kind:any) =>{
      if(kind == "point"){
        return "subarea";
      }else if(kind == "subarea"){
        return "area";
      }else if(kind == "area"){
        return "range";
      }else{
        return null
      }
  }




  React.useEffect(() => {
    setData(_transformData(props.data));
  }, [props.data]);

  function _transformData(data: any) {
    // console.log("_transformData, data:", data);
    const dataCopy = JSON.parse(JSON.stringify(data));
    const treeData = dataCopy
      .filter((e: any) => {
        return e.kind === "range";
      })
      .map((e: any) => {
        return { ...e };
      })
      .sort((a: any, b: any) => {
        return a.serialNo - b.serialNo;
      });

    // console.log("_transformData, ranges:", treeData);

    treeData.forEach((range: any) => {
      const areas = dataCopy
        .filter((e: any) => {
          return e.kind === "area" && e.parent === range.name;
        })
        .sort((a: any, b: any) => {
          return a.serialNo - b.serialNo;
        });
      areas.forEach((area: any) => {
        const subareas = dataCopy
          .filter((e: any) => {
            return e.kind === "subarea" && e.parent === area.name;
          })
          .sort((a: any, b: any) => {
            return a.serialNo - b.serialNo;
          });
        subareas.forEach((subarea: any) => {
          const points = dataCopy
            .filter((e: any) => {
              return e.kind === "point" && e.parent === subarea.name;
            })
            .map((e: any) => {
              return { ...e, children: [] };
            })
            .sort((a: any, b: any) => {
              return a.serialNo - b.serialNo;
            });
          subarea["children"] = points;
          subarea["subRows"] = points;
        });
        area["children"] = subareas;
        area["subRows"] = subareas;
      });
      range["children"] = areas;
      range["subRows"] = areas;
    });
    return treeData;
  }

  function moveUp(ranges: any, record: any) {
    const key = record["key"];
    console.log("moveUp, before: ", ranges);
    if (record["kind"] === "range") {
      for (let i = 0; i < ranges.length; ++i) {
        if (ranges[i]["key"] === key) {
          moveUpImpl(ranges, i);
          console.log("moveUp, after: ", ranges);
          return ranges;
        }
      }
    }
    if (record["kind"] === "area") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          if (areas[j]["key"] === key) {
            moveUpImpl(areas, j);
            console.log("moveUp, after: ", ranges);
            return ranges;
          }
        }
      }
    }
    if (record["kind"] === "subarea") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          const subareas = areas[j].children;
          for (let k = 0; k < subareas.length; ++k) {
            if (subareas[k]["key"] === key) {
              moveUpImpl(subareas, k);
              console.log("moveUp, after: ", ranges);
              return ranges;
            }
          }
        }
      }
    }
    if (record["kind"] === "point") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          const subareas = areas[j].children;
          for (let k = 0; k < subareas.length; ++k) {
            const points = subareas[k].children;
            for (let l = 0; l < points.length; ++l) {
              if (points[l]["key"] === key) {
                moveUpImpl(points, l);
                console.log("moveUp, after: ", ranges);
                return ranges;
              }
            }
          }
        }
      }
    }
    return ranges;
  }

  function moveUpImpl(array: any, index: any) {
    console.log("moveUpImpl, array:", array);
    if (index <= 0) {
      return;
    }
    const apiParams = {
      bandobastId: props.bandobastId,
      timeslotId: props.timeslotId,
      formData: [
        {
          id: array[index].key,
          serialNo: array[index].serialNo,
        },
        {
          id: array[index - 1].key,
          serialNo: array[index - 1].serialNo,
        },
      ],
    };

    swapSerialNos(apiParams);
  }

  function moveDown(ranges: any, record: any) {
    const key = record["key"];
    console.log("moveDown, before: ", ranges);
    if (record["kind"] === "range") {
      for (let i = 0; i < ranges.length; ++i) {
        if (ranges[i]["key"] === key) {
          moveDownImpl(ranges, i);
          console.log("moveDown, after: ", ranges);
          return ranges;
        }
      }
    }
    if (record["kind"] === "area") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          if (areas[j]["key"] === key) {
            moveDownImpl(areas, j);
            console.log("moveDown, after: ", ranges);
            return ranges;
          }
        }
      }
    }
    if (record["kind"] === "subarea") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          const subareas = areas[j].children;
          for (let k = 0; k < subareas.length; ++k) {
            if (subareas[k]["key"] === key) {
              moveDownImpl(subareas, k);
              console.log("moveDown, after: ", ranges);
              return ranges;
            }
          }
        }
      }
    }
    if (record["kind"] === "point") {
      for (let i = 0; i < ranges.length; ++i) {
        const areas = ranges[i].children;
        for (let j = 0; j < areas.length; ++j) {
          const subareas = areas[j].children;
          for (let k = 0; k < subareas.length; ++k) {
            const points = subareas[k].children;
            for (let l = 0; l < points.length; ++l) {
              if (points[l]["key"] === key) {
                moveDownImpl(points, l);
                console.log("moveDown, after: ", ranges);
                return ranges;
              }
            }
          }
        }
      }
    }
    return ranges;
  }

  function moveDownImpl(array: any, index: any) {
    console.log("moveDownImpl, array:", array);
    if (index >= array.length - 1) {
      return;
    }
    const apiParams = {
      bandobastId: props.bandobastId,
      timeslotId: props.timeslotId,
      formData: [
        {
          id: array[index].key,
          serialNo: array[index].serialNo,
        },
        {
          id: array[index + 1].key,
          serialNo: array[index + 1].serialNo,
        },
      ],
    };

    swapSerialNos(apiParams);
  }

  const navigate = useNavigate();

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);
  const [uploadDialogOpen, setUploadDialogOpen] = React.useState(false);

  const columns: ColumnsType<Location> = [
    {
      title: strings.name,
      dataIndex: "name",
      key: "name",
      width: 900,
    },
    {
      title: strings.kind,
      dataIndex: "kind",
      key: "kind",
      width: 30,
      render: (text, record, index) => getLocationStrMap().get(record.kind)!,
    },
    {
      title: strings.personnelAssessmentCount,
      dataIndex: "personnelAssessmentCount",
      key: "personnelAssessmentCount",
      width: 10,
      render: (text, record, index) => (
        <Button
          id={`personnelAssessmentCount${index}`}
          onClick={() => {
            const toStore = {
              id: record.key,
              name: record.name,
              kind: record.kind,
            };
            localStorage.setItem("location", JSON.stringify(toStore));
            navigate(
              `../personnelAssessments/${props.bandobastId}/${props.timeslotId}/${record.key}`,
            );
          }}
        >
          {text as string}
        </Button>
      ),
    },
    {
      title: strings.resourceAssessmentCount,
      dataIndex: "resourceAssessmentCount",
      key: "resourceAssessmentCount",
      width: 10,
      render: (text, record, index) => (
        <Button
          id={`resourceAssessmentCount${index}`}
          onClick={() => {
            const toStore = {
              id: record.key,
              name: record.name,
              kind: record.kind,
            };
            localStorage.setItem("location", JSON.stringify(toStore));
            navigate(
              `../resourceAssessments/${props.bandobastId}/${props.timeslotId}/${record.key}`,
            );
          }}
        >
          {text as string}
        </Button>
      ),
    },
    {
      title: strings.personnelAllocationCount,
      dataIndex: "personnelAllocationCount",
      key: "personnelAllocationCount",
      width: 10,
      render: (text, record, index) => (
        <Button
          onClick={() => {
            const toStore = {
              id: record.key,
              name: record.name,
              kind: record.kind,
            };
            localStorage.setItem("location", JSON.stringify(toStore));
            navigate(
              `../personnelAllocations/${props.bandobastId}/${props.timeslotId}/${record.key}`,
            );
          }}
        >
          {text as string}
        </Button>
      ),
    },
    {
      title: strings.resourceAllocationCount,
      dataIndex: "resourceAllocationCount",
      key: "resourceAllocationCount",
      width: 10,
      render: (text, record, index) => (
        <Button
          onClick={() => {
            const toStore = {
              id: record.key,
              name: record.name,
              kind: record.kind,
            };
            localStorage.setItem("location", JSON.stringify(toStore));
            navigate(
              `../resourceAllocations/${props.bandobastId}/${props.timeslotId}/${record.key}`,
            );
          }}
        >
          {text as string}
        </Button>
      ),
    },
    {
      title: "",
      dataIndex: "moveUp",
      key: "moveUp",
      width: 1,
      render: (text, record, index) => (
        <IconButton
          color="secondary"
          onClick={() => {
            console.log("in move up, text, record, index", text, record, index);
            moveUp(data, record);
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      ),
    },
    {
      title: "",
      dataIndex: "moveDown",
      key: "moveDown",
      width: 1,
      render: (text, record, index) => (
        <IconButton
          color="secondary"
          onClick={() => {
            console.log(
              "in move down, text, record, index",
              text,
              record,
              index,
            );
            moveDown(data, record);
          }}
        >
          <ArrowDownwardIcon />
        </IconButton>
      ),
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: 1,
      render: (text, record, index) =>
        doesPermissionExist("update-location") && (
          <EditLocation
            bandobastId={props.bandobastId!}
            timeslotId={props.timeslotId!}
            id={record.key}
            initialValues={record}
          />
        ),
    },
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: 1,
      render: (text, record, index) =>
        doesPermissionExist("delete-location") && (
          <DeleteLocation
            bandobastId={props.bandobastId!}
            timeslotId={props.timeslotId}
            id={record.key}
          />
        ),
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonGroup>
            <NewButton
              onClickHandler={() => {
                setNewDialogOpen(true);
              }}
            />
            <NewLocation
              bandobastId={props.bandobastId!}
              timeslotId={props.timeslotId!}
              onSubmitHandler={(newObj: any) => {
                console.log("onSubmitHandler, newObj:", newObj);
                setNewDialogOpen(false);
              }}
              onCancelHandler={() => {
                console.log("onCancelHandler");
                setNewDialogOpen(false);
              }}
              state={newDialogOpen}
              coordinate={undefined}
            />
            <UploadButton
              onClickHandler={() => {
                setUploadDialogOpen(true);
              }}
            />
            <UploadLocations
              state={uploadDialogOpen}
              bandobastId={props.bandobastId!}
              timeslotId={props.timeslotId!}
              onSubmitHandler={(newObj: any) => {
                console.log("onSubmitHandler, newObj:", newObj);
                setUploadDialogOpen(false);
              }}
              onCancelHandler={() => {
                console.log("onCancelHandler");
                setUploadDialogOpen(false);
              }}
            />
          </ButtonGroup>
        </Grid>
        <Grid item xs={12}>
          {/* <Table
            columns={columns}
            scroll={{ x: 1000 }}
            expandable={{ defaultExpandAllRows: true }}
            dataSource={data}
            pagination={false}
          /> */}


          <MantineReactTable table={table} />



        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            {strings.back}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
